// Les champs "date" de l'admin sont du texte libre bilingue ("2023 - Aujourd'hui",
// "Été 2022", "Avril - Juin 2023") — pas de date structurée en base. On extrait la
// première année à 4 chiffres pour permettre tri/filtre par période sans migration.
export const extractYear = (text) => {
  const match = String(text || '').match(/\d{4}/);
  return match ? Number(match[0]) : null;
};
